import React from 'react';

import NewFeature24Icon from '@atlaskit/icon-object/glyph/new-feature/24';

export default (): React.JSX.Element => <NewFeature24Icon label="" />;
